import Todo from "./TodoList/Todo";

function App() {
  return (
    <div>
      <Todo />
    </div>
  );
}
export default App;
